import React from 'react'
import { useDispatch } from 'react-redux'

import { useConfirmationModal, useLanguage, useModal } from 'hooks'
import { interviewTemplates } from 'orm'
import { useCreateInterviewTemplateForm } from './common/CreateInterviewTemplateForm/hooks'

const useCreateInterviewTemplateModalMutations = () => {
  const dispatch = useDispatch()

  const handlePostInterviewTemplate = React.useCallback(
    ({ data }, { onFailureAction, postSuccessAction } = {}) => {
      dispatch(
        interviewTemplates.postStart({
          data,
          onFailureAction,
          postSuccessAction,
        }),
      )
    },
    [dispatch],
  )

  return {
    handlePostInterviewTemplate,
  }
}

export const useCreateInterviewTemplateModalState = handlers => {
  const { onCancel, onClose, onConfirm } = handlers

  const language = useLanguage()

  const {
    state: { competencies, control, formState, isDirtyOrInvalid },
    handlers: { handleFormReset, handleFormSubmit, watch },
  } = useCreateInterviewTemplateForm({ onClose, onConfirm })

  const {
    handleConfirmationClose,
    handleConfirmationConfirm,
    handleConfirmationOpen,
    isConfirmationOpen,
  } = useConfirmationModal(() => {
    handleFormReset()
    onClose()
  })

  const handleCancel = React.useCallback(() => {
    isDirtyOrInvalid ? handleConfirmationOpen() : onCancel()
  }, [isDirtyOrInvalid, handleConfirmationOpen, onCancel])

  const handleClose = React.useCallback(() => {
    isDirtyOrInvalid ? handleConfirmationOpen() : onClose()
  }, [isDirtyOrInvalid, handleConfirmationOpen, onClose])

  const handleConfirm = React.useCallback(handleFormSubmit, [handleFormSubmit])

  return {
    state: {
      form: { competencies, control, formState, watch },
      language,
      isConfirmationOpen,
    },
    handlers: {
      handleCancel,
      handleClose,
      handleConfirm,
      handleConfirmationClose,
      handleConfirmationConfirm,
    },
  }
}

export const useCreateInterviewTemplateModal = () => {
  const { handleClose, handleOpen, isOpen } = useModal()

  const {
    handlePostInterviewTemplate,
  } = useCreateInterviewTemplateModalMutations()

  const handleConfirm = React.useCallback(
    (data, { onFailureAction, postSuccessAction } = {}) => {
      handlePostInterviewTemplate(
        { data },
        { onFailureAction, postSuccessAction },
      )
    },
    [handlePostInterviewTemplate],
  )

  return {
    handleCreateInteviewTemplateClose: handleClose,
    handleCreateInterviewTemplateConfirm: handleConfirm,
    handleCreateInteviewTemplateOpen: handleOpen,
    isCreateInterviewTemplateOpen: isOpen,
  }
}
